module.exports = __webpack_public_path__ + "d6cff105e4c9a42a50eefdf7887ee5f7.svg";